import { loadScript } from '/src/utils';

let INTERCOM_APP_ID = '';
let INTERCOM_API_BASE = '';
let INTERCOM_ENABLE = '';

const intercomSettings = {
    custom_launcher_selector: '.intercom_launcher_link',
    alignment: 'right',
    horizontal_padding: 20,
    vertical_padding: 70,
};

const intercomLoad = (app_id, intercom_api_base, intercom_enable) => {
    INTERCOM_APP_ID = app_id;
    INTERCOM_API_BASE = intercom_api_base;
    INTERCOM_ENABLE = +intercom_enable;
    const i = function() { i.c(arguments) };
    i.q = [];
    i.c = function(args) { i.q.push(args) };
    window.Intercom = i;

    if (!!INTERCOM_ENABLE) {
        setTimeout(() => {
            loadScript('https://widget.intercom.io/widget/b1y3yb28')
                .catch(() => console.log('load intercom error'))
        }, 5000);

        window.Intercom('boot', {
            ...intercomSettings,
            app_id: INTERCOM_APP_ID,
            api_base: INTERCOM_API_BASE,
        });
    }
};

const intercomLoginUser = ({ intercomUserJwt }) => {
    if (!!INTERCOM_ENABLE) {
        window.Intercom('shutdown');
        window.Intercom('boot', {
            ...intercomSettings,
            app_id: INTERCOM_APP_ID,
            api_base: INTERCOM_API_BASE,
            intercom_user_jwt: intercomUserJwt,
        });
    }
};

const intercomLogoutUser = () => {
    if (!!INTERCOM_ENABLE) {
        window.Intercom('shutdown');
        window.Intercom('boot', {
            ...intercomSettings,
            app_id: INTERCOM_APP_ID,
            api_base: INTERCOM_API_BASE,
        });
    }
};

export {
    intercomLoad,
    intercomLoginUser,
    intercomLogoutUser,
};
